import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { Spinner, Icon, TextInput, Pane, Label, Textarea, Dialog } from 'evergreen-ui';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Row, Col, Container, Form, Button, Alert } from 'react-bootstrap';
import Login from './login';
import Select from 'react-select';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Autocomplete from '@mui/material/Autocomplete';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Component from "@reactions/component";

const cookies = new Cookies();
const urlParams = new URLSearchParams(window.location.search);
let listId = urlParams.get('id');

// دالة تنظيف النص من الرموز والفراغات
const normalizeText = (text) => {
    if (!text) return '';
    return text
        .toLowerCase()
        .replace(/[.\-_()\/\\,]/g, ' ')  // استبدال الرموز بفراغات
        .replace(/\s+/g, ' ')             // إزالة الفراغات المتعددة
        .trim();
};

// دالة استخراج الكلمات المفتاحية الأساسية (بدون الذاكرة والأحرف الملحقة)
const extractKeywords = (text) => {
    if (!text) return [];
    const normalized = normalizeText(text);
    
    // إزالة كلمات الذاكرة والألوان الشائعة
    const stopWords = ['gb', 'tb', 'mb', 'wifi', 'cellular', 'black', 'white', 'gold', 'silver', 'gray', 'grey', 'space', 'rose', 'blue', 'red', 'green', 'yellow', 'purple', 'pink'];
    
    let words = normalized.split(' ').filter(word => word.length > 0);
    
    // معالجة كل كلمة
    words = words.map(word => {
        // إذا كانت الكلمة رقم + حرف مثل 6g, 6s, 11pro
        // نستخرج الرقم فقط
        const numMatch = word.match(/^(\d+)/);
        if (numMatch && word.length > numMatch[1].length) {
            return numMatch[1]; // نرجع الرقم فقط
        }
        return word;
    });
    
    // إزالة الكلمات غير المهمة وأرقام الذاكرة (أرقام كبيرة مثل 64, 128, 256)
    words = words.filter(word => {
        if (stopWords.includes(word)) return false;
        // إذا كان رقم أكبر من 20 غالباً يكون ذاكرة
        const num = parseInt(word);
        if (!isNaN(num) && num > 20) return false;
        return true;
    });
    
    return words;
};

// دالة فلترة الأجهزة النهائية بناءً على الجهاز الأولي
const filterMatchingDevices = (sourceDevice, targetDevices) => {
    if (!sourceDevice || !sourceDevice.name || !targetDevices) {
        return targetDevices || [];
    }
    
    const sourceKeywords = extractKeywords(sourceDevice.name);
    
    if (sourceKeywords.length === 0) {
        return targetDevices;
    }
    
    // فلترة الأجهزة التي تحتوي على جميع الكلمات المفتاحية
    const filtered = targetDevices.filter(device => {
        if (!device.name) return false;
        const targetKeywords = extractKeywords(device.name);
        const targetNormalized = normalizeText(device.name);
        
        // التحقق من وجود جميع الكلمات المفتاحية
        return sourceKeywords.every(keyword => {
            // نبحث في الكلمات المستخرجة أو في النص الكامل
            return targetKeywords.includes(keyword) || targetNormalized.includes(keyword);
        });
    });
    
    // إذا لم يتم العثور على نتائج، نرجع القائمة الأصلية
    return filtered.length > 0 ? filtered : targetDevices;
};

// Custom MUI Theme for Arabic RTL
const theme = createTheme({
    direction: 'rtl',
    typography: {
        fontFamily: 'Tajawal, Cairo, sans-serif',
    },
    palette: {
        primary: {
            main: '#6366f1',
        },
        secondary: {
            main: '#ec4899',
        },
    },
    components: {
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '16px',
                        backgroundColor: 'rgba(255,255,255,0.95)',
                        backdropFilter: 'blur(10px)',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        fontFamily: 'Tajawal, sans-serif',
                        '& input': {
                            textAlign: 'right',
                            direction: 'rtl',
                            fontFamily: 'Tajawal, sans-serif',
                            fontSize: '15px',
                            fontWeight: 500,
                            color: '#1e293b',
                            '&::placeholder': {
                                color: '#94a3b8',
                                opacity: 1,
                            },
                        },
                        '&:hover': {
                            backgroundColor: '#fff',
                            boxShadow: '0 8px 32px rgba(99, 102, 241, 0.15)',
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#6366f1',
                            },
                        },
                        '&.Mui-focused': {
                            backgroundColor: '#fff',
                            boxShadow: '0 12px 40px rgba(99, 102, 241, 0.25)',
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#6366f1',
                                borderWidth: '2px',
                            },
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#e2e8f0',
                            transition: 'all 0.3s ease',
                        },
                    },
                    '& .MuiInputLabel-root': {
                        right: 28,
                        left: 'auto',
                        transformOrigin: 'right',
                        fontFamily: 'Tajawal, sans-serif',
                        fontWeight: 500,
                        color: '#64748b',
                        '&.Mui-focused': {
                            color: '#6366f1',
                        },
                    },
                    '& .MuiInputLabel-shrink': {
                        transform: 'translate(0, -9px) scale(0.75)',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        textAlign: 'right',
                    },
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        paddingRight: '14px !important',
                        paddingLeft: '40px !important',
                    },
                    '& .MuiAutocomplete-endAdornment': {
                        left: '9px',
                        right: 'auto',
                    },
                },
                paper: {
                    borderRadius: '16px',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
                    marginTop: '8px',
                    border: '1px solid rgba(99, 102, 241, 0.2)',
                    backgroundColor: '#fff',
                    overflow: 'hidden',
                },
                listbox: {
                    padding: '8px',
                    maxHeight: '300px',
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: '#f1f5f9',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                        borderRadius: '4px',
                    },
                },
                option: {
                    fontFamily: 'Tajawal, sans-serif',
                    padding: '14px 20px',
                    margin: '4px 0',
                    borderRadius: '12px',
                    fontSize: '15px',
                    fontWeight: 500,
                    color: '#1e293b',
                    transition: 'all 0.2s ease',
                    direction: 'rtl',
                    textAlign: 'right',
                    '&:hover': {
                        backgroundColor: 'rgba(99, 102, 241, 0.1)',
                    },
                    '&[aria-selected="true"]': {
                        backgroundColor: 'rgba(99, 102, 241, 0.15)',
                        color: '#4338ca',
                        fontWeight: 600,
                    },
                    '&.Mui-focused': {
                        backgroundColor: 'rgba(99, 102, 241, 0.1)',
                    },
                    '&[aria-disabled="true"]': {
                        opacity: 0.5,
                        color: '#94a3b8',
                    },
                },
                noOptions: {
                    fontFamily: 'Tajawal, sans-serif',
                    padding: '20px',
                    textAlign: 'center',
                    color: '#64748b',
                    fontSize: '14px',
                },
                loading: {
                    fontFamily: 'Tajawal, sans-serif',
                    padding: '20px',
                    textAlign: 'center',
                    color: '#6366f1',
                },
            },
        },
    },
});

// Custom styles for react-select
const customSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        borderRadius: '16px',
        border: state.isFocused ? '2px solid #6366f1' : '1px solid #e2e8f0',
        backgroundColor: 'rgba(255,255,255,0.95)',
        backdropFilter: 'blur(10px)',
        minHeight: '56px',
        boxShadow: state.isFocused ? '0 12px 40px rgba(99, 102, 241, 0.25)' : '0 4px 16px rgba(0,0,0,0.05)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        direction: 'rtl',
        textAlign: 'right',
        '&:hover': {
            borderColor: '#6366f1',
            boxShadow: '0 8px 32px rgba(99, 102, 241, 0.15)',
        },
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '2px 16px',
        direction: 'rtl',
        flexDirection: 'row',
    }),
    input: (provided) => ({
        ...provided,
        margin: '0',
        padding: '0',
        direction: 'rtl',
        textAlign: 'right',
    }),
    placeholder: (provided) => ({
        ...provided,
        fontFamily: 'Tajawal, sans-serif',
        color: '#94a3b8',
        textAlign: 'right',
    }),
    singleValue: (provided) => ({
        ...provided,
        fontFamily: 'Tajawal, sans-serif',
        textAlign: 'right',
    }),
    menu: (provided) => ({
        ...provided,
        borderRadius: '16px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
        overflow: 'hidden',
        zIndex: 9999,
        direction: 'rtl',
        position: 'absolute',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '8px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#6366f1' : state.isFocused ? 'rgba(99, 102, 241, 0.1)' : '#fff',
        color: state.isSelected ? '#fff' : '#1e293b',
        padding: '14px 20px',
        fontFamily: 'Tajawal, sans-serif',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        borderRadius: '10px',
        marginBottom: '4px',
        textAlign: 'right',
        direction: 'rtl',
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#6366f1',
        borderRadius: '10px',
        padding: '2px 4px',
        direction: 'rtl',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#fff',
        fontFamily: 'Tajawal, sans-serif',
        fontWeight: 500,
        padding: '4px 8px',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#fff',
        borderRadius: '0 8px 8px 0',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#ef4444',
            color: '#fff',
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        cursor: 'pointer',
        padding: '8px',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        cursor: 'pointer',
        padding: '8px',
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        flexDirection: 'row-reverse',
    }),
};

// Inline styles as JavaScript objects
const styles = {
    pageWrapper: {
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #312e81 100%)',
        position: 'relative',
        overflow: 'hidden',
    },
    backgroundOrbs: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
        zIndex: 0,
    },
    orb1: {
        position: 'absolute',
        width: '600px',
        height: '600px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(99, 102, 241, 0.3) 0%, transparent 70%)',
        top: '-200px',
        right: '-200px',
        animation: 'float 20s ease-in-out infinite',
    },
    orb2: {
        position: 'absolute',
        width: '500px',
        height: '500px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(236, 72, 153, 0.2) 0%, transparent 70%)',
        bottom: '-150px',
        left: '-150px',
        animation: 'float 25s ease-in-out infinite reverse',
    },
    orb3: {
        position: 'absolute',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(34, 211, 238, 0.2) 0%, transparent 70%)',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        animation: 'pulse 10s ease-in-out infinite',
    },
    navbar: {
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        padding: '16px 32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
    },
    backButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        color: '#fff',
        textDecoration: 'none',
        padding: '12px 24px',
        borderRadius: '14px',
        background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(139, 92, 246, 0.2))',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        fontFamily: 'Tajawal, sans-serif',
        fontWeight: 600,
        cursor: 'pointer',
    },
    pageTitle: {
        color: '#fff',
        fontFamily: 'Tajawal, sans-serif',
        fontWeight: 700,
        fontSize: '1.5rem',
        background: 'linear-gradient(135deg, #fff, #c7d2fe)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
    },
    mainContent: {
        position: 'relative',
        zIndex: 1,
        padding: '40px 24px',
        maxWidth: '1400px',
        margin: '0 auto',
    },
    card: {
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(20px)',
        borderRadius: '28px',
        padding: '40px',
        boxShadow: '0 25px 80px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1) inset',
        marginBottom: '32px',
        border: '1px solid rgba(255, 255, 255, 0.2)',
    },
    sectionTitle: {
        fontFamily: 'Tajawal, sans-serif',
        fontWeight: 700,
        fontSize: '1.1rem',
        color: '#1e293b',
        marginBottom: '16px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    sectionIcon: {
        width: '36px',
        height: '36px',
        borderRadius: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '18px',
    },
    inputWrapper: {
        marginTop: '12px',
    },
    styledTextInput: {
        width: '100%',
        height: '56px',
        borderRadius: '16px',
        border: '1px solid #e2e8f0',
        padding: '0 20px',
        fontSize: '16px',
        fontFamily: 'Tajawal, sans-serif',
        backgroundColor: 'rgba(255,255,255,0.9)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        outline: 'none',
        direction: 'rtl',
    },
    styledTextarea: {
        width: '100%',
        minHeight: '120px',
        borderRadius: '16px',
        border: '1px solid #e2e8f0',
        padding: '16px 20px',
        fontSize: '16px',
        fontFamily: 'Tajawal, sans-serif',
        backgroundColor: 'rgba(255,255,255,0.9)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        resize: 'vertical',
        outline: 'none',
        direction: 'rtl',
    },
    divider: {
        height: '2px',
        background: 'linear-gradient(90deg, transparent, #e2e8f0, transparent)',
        margin: '32px 0',
        border: 'none',
    },
    alertBox: {
        borderRadius: '16px',
        padding: '20px 24px',
        fontFamily: 'Tajawal, sans-serif',
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        marginBottom: '20px',
    },
    alertInfo: {
        background: 'linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(139, 92, 246, 0.1))',
        border: '1px solid rgba(99, 102, 241, 0.3)',
        color: '#4338ca',
    },
    alertSuccess: {
        background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(5, 150, 105, 0.1))',
        border: '1px solid rgba(16, 185, 129, 0.3)',
        color: '#047857',
    },
    alertDanger: {
        background: 'linear-gradient(135deg, rgba(239, 68, 68, 0.1), rgba(220, 38, 38, 0.1))',
        border: '1px solid rgba(239, 68, 68, 0.3)',
        color: '#b91c1c',
    },
    radioGroup: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px',
        justifyContent: 'center',
        marginTop: '16px',
    },
    radioCard: {
        position: 'relative',
        cursor: 'pointer',
    },
    radioInput: {
        position: 'absolute',
        opacity: 0,
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        zIndex: 2,
    },
    radioLabel: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '16px 28px',
        borderRadius: '16px',
        background: '#f8fafc',
        border: '2px solid #e2e8f0',
        fontFamily: 'Tajawal, sans-serif',
        fontWeight: 600,
        fontSize: '15px',
        color: '#475569',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        cursor: 'pointer',
    },
    submitButton: {
        background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
        color: '#fff',
        border: 'none',
        padding: '18px 48px',
        borderRadius: '16px',
        fontFamily: 'Tajawal, sans-serif',
        fontWeight: 700,
        fontSize: '18px',
        cursor: 'pointer',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        boxShadow: '0 10px 40px rgba(99, 102, 241, 0.4)',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    },
    loaderWrapper: {
        display: 'flex',
        justifyContent: 'center',
        padding: '20px',
    },
    // أنماط خطأ البطارية
    batteryInputError: {
        borderColor: '#ef4444',
        boxShadow: '0 0 0 3px rgba(239, 68, 68, 0.2)',
    },
    batteryErrorText: {
        color: '#ef4444',
        fontSize: '13px',
        fontFamily: 'Tajawal, sans-serif',
        marginTop: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
    },
};

// CSS Keyframes as a style tag
const GlobalStyles = () => (
    <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;600;700;800&display=swap');
        
        @keyframes float {
            0%, 100% { transform: translateY(0) rotate(0deg); }
            50% { transform: translateY(-30px) rotate(5deg); }
        }
        
        @keyframes pulse {
            0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 0.5; }
            50% { transform: translate(-50%, -50%) scale(1.2); opacity: 0.8; }
        }
        
        @keyframes shimmer {
            0% { background-position: -200% 0; }
            100% { background-position: 200% 0; }
        }
        
        .styled-input:focus {
            border-color: #6366f1 !important;
            box-shadow: 0 12px 40px rgba(99, 102, 241, 0.25) !important;
            background-color: #fff !important;
        }
        
        .styled-input:hover {
            border-color: #6366f1;
            box-shadow: 0 8px 32px rgba(99, 102, 241, 0.15);
        }
        
        .styled-input.input-error {
            border-color: #ef4444 !important;
            box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.2) !important;
        }
        
        .styled-input.input-error:focus {
            border-color: #ef4444 !important;
            box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3) !important;
        }
        
        .radio-card input:checked + label {
            background: linear-gradient(135deg, #6366f1, #8b5cf6) !important;
            border-color: transparent !important;
            color: #fff !important;
            box-shadow: 0 8px 32px rgba(99, 102, 241, 0.4) !important;
            transform: translateY(-2px);
        }
        
        .radio-card label:hover {
            border-color: #6366f1;
            background: rgba(99, 102, 241, 0.05);
            transform: translateY(-2px);
        }
        
        .submit-btn:hover {
            transform: translateY(-3px);
            box-shadow: 0 15px 50px rgba(99, 102, 241, 0.5) !important;
        }
        
        .submit-btn:active {
            transform: translateY(0);
        }
        
        .back-btn:hover {
            background: linear-gradient(135deg, rgba(99, 102, 241, 0.4), rgba(139, 92, 246, 0.4)) !important;
            transform: translateX(-5px);
        }
        
        .card-animate {
            animation: fadeInUp 0.6s ease-out forwards;
            opacity: 0;
        }
        
        @keyframes fadeInUp {
            from {
                opacity: 0;
                transform: translateY(30px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }
        
        .card-animate:nth-child(1) { animation-delay: 0.1s; }
        .card-animate:nth-child(2) { animation-delay: 0.2s; }
        .card-animate:nth-child(3) { animation-delay: 0.3s; }
        
        .MuiAutocomplete-root {
            width: 100% !important;
        }
        
        .MuiAutocomplete-inputRoot {
            padding-right: 14px !important;
            padding-left: 40px !important;
        }
        
        .MuiAutocomplete-endAdornment {
            left: 9px !important;
            right: auto !important;
        }
        
        .MuiAutocomplete-clearIndicator {
            margin-left: 0 !important;
            margin-right: -8px !important;
        }
        
        .MuiAutocomplete-listbox {
            padding: 8px !important;
        }
        
        .MuiAutocomplete-option {
            border-radius: 12px !important;
            margin: 4px 8px !important;
            transition: all 0.2s ease !important;
        }
        
        .MuiAutocomplete-option:hover {
            background-color: rgba(99, 102, 241, 0.08) !important;
        }
        
        .MuiAutocomplete-option[aria-selected="true"] {
            background-color: rgba(99, 102, 241, 0.12) !important;
        }
        
        .MuiAutocomplete-paper {
            border-radius: 16px !important;
            box-shadow: 0 20px 60px rgba(0,0,0,0.15), 0 0 0 1px rgba(99, 102, 241, 0.1) !important;
            border: 1px solid rgba(99, 102, 241, 0.15) !important;
            margin-top: 8px !important;
            overflow: hidden !important;
        }
        
        .MuiAutocomplete-noOptions {
            font-family: 'Tajawal', sans-serif !important;
            text-align: center !important;
            color: #64748b !important;
            padding: 20px !important;
        }
    `}</style>
);

class Category extends React.Component {
    selectRef = null;
    outDeviceRef = null;
    
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            outItems: [],
            filteredOutItems: [],
            outDeviceKey: 0,
            spin: false,
            options: [],
            optionsSelcted: [],
            itemIn: {},
            itemOut: "",
            isLoding: false,
            isConfirmLoading: false,
            listId: listId,
            fields: { value: 'name', disabled: 'disabled' },
            // حالة التحقق من البطارية
            batteryValue: '',
            batteryError: false,
            batteryErrorMessage: ''
        };
        this.get_list_items(listId);
    }

    clearValue = () => {
        if (this.selectRef?.select) {
            this.selectRef.select.clearValue();
        }
    };

    componentDidMount() {
        const phoneInput = document.getElementById("phoneInput");
        if (phoneInput) phoneInput.disabled = true;

        axios.get(host + `users/get/items/sana/all`)
            .then(res => {
                this.setState({ 
                    outItems: res.data.items,
                    filteredOutItems: res.data.items 
                });
            })
            .catch(error => {
                console.log(error.response);
            });
    }

    get_list_items(value) {
        axios.get(host + `users/sana/lists/byid/${value}`)
            .then(res => {
                const phoneInput = document.getElementById("phoneInput");
                if (phoneInput) phoneInput.disabled = false;
                this.setState({ items: res.data.items });
            })
            .catch(error => {
                window.alert('تأكد من رقم القائمة');
                this.setState({ items: [] });
                console.log(error.response);
            });
    }

    onSelect(selectedList) {
        this.clearValue();
        
        const sppEl = document.getElementById('spp');
        const pslEl = document.getElementById('psl');
        
        if (sppEl) sppEl.style.display = "flex";
        if (pslEl) pslEl.style.display = "none";

        // فلترة الأجهزة النهائية بناءً على الجهاز الأولي المختار
        const filtered = filterMatchingDevices(selectedList, this.state.outItems);
        this.setState({ 
            filteredOutItems: filtered,
            itemOut: "",
            outDeviceKey: this.state.outDeviceKey + 1 // إعادة تعيين حقل الجهاز النهائي
        });

        axios.get(host + `users/parts/${selectedList.item_id}`)
            .then(res => {
                if (sppEl) sppEl.style.display = "none";
                if (pslEl) pslEl.style.display = "block";
                this.setState({ options: res.data.parts, itemIn: selectedList });
            })
            .catch(error => {
                if (sppEl) sppEl.style.display = "none";
                if (pslEl) pslEl.style.display = "block";
                console.log(error.response);
            });
    }

    onRemove(item) {
        this.setState({ 
            options: [], 
            itemIn: {},
            filteredOutItems: this.state.outItems // إعادة عرض جميع الأجهزة
        });
    }

    onSelectFin(selectedList) {
        if (!selectedList) {
            this.setState({ itemOut: {} });
        } else {
            this.setState({ itemOut: selectedList });
        }
    }

    onRemoveFin(item) {
        this.setState({ itemOut: {} });
    }

    // دالة التحقق من نسبة البطارية
    validateBattery = (value) => {
        // إذا كان الحقل فارغاً، لا يوجد خطأ (اختياري)
        if (value === '' || value === null || value === undefined) {
            return { isValid: true, errorMessage: '' };
        }

        const numValue = parseInt(value, 10);

        // التحقق من أن القيمة رقم صحيح
        if (isNaN(numValue)) {
            return { isValid: false, errorMessage: 'يرجى إدخال رقم صحيح' };
        }

        // التحقق من النطاق (1-100)
        if (numValue < 1) {
            return { isValid: false, errorMessage: 'نسبة البطارية يجب أن تكون 1 على الأقل' };
        }

        if (numValue > 100) {
            return { isValid: false, errorMessage: 'نسبة البطارية يجب ألا تتجاوز 100' };
        }

        return { isValid: true, errorMessage: '' };
    };

    // معالج تغيير قيمة البطارية
    handleBatteryChange = (e) => {
        const value = e.target.value;
        const validation = this.validateBattery(value);
        
        this.setState({
            batteryValue: value,
            batteryError: !validation.isValid,
            batteryErrorMessage: validation.errorMessage
        });
    };

    addNew() {
        let _inItem = this.state.itemIn;
        let _ouItem = this.state.itemOut;
        let op = this.state.optionsSelcted;
        let c_id = document.getElementById("c_id").value;
        let notes = document.getElementById("notes").value;
        let battery = this.state.batteryValue;
        let list_id = document.getElementById("list_id").value;

        var radios = document.getElementsByName('group1');
        var radios2 = document.getElementsByName('group2');

        let check = "";
        let check2 = "";

        for (var i = 0, length = radios.length; i < length; i++) {
            if (radios[i].checked) {
                check = radios[i].value;
                break;
            }
        }
        for (var i = 0, length = radios2.length; i < length; i++) {
            if (radios2[i].checked) {
                check2 = radios2[i].value;
                break;
            }
        }

        if (!check2) {
            toast.error('اختر نوع الفحص', { position: 'bottom-right' });
            return -1;
        }
        if (!c_id) {
            toast.error('ادخل الرقم التسلسلي', { position: 'bottom-right' });
            return -1;
        }
        if (!check) {
            toast.error('اختر نوع التحويل', { position: 'bottom-right' });
            return -1;
        }
        if (!_ouItem) {
            toast.error('ادخل الجهاز النهائي مع الذاكرة', { position: 'bottom-right' });
            return -1;
        }

        // التحقق من صحة نسبة البطارية إذا تم إدخالها
        if (battery !== '' && battery !== null && battery !== undefined) {
            const batteryValidation = this.validateBattery(battery);
            if (!batteryValidation.isValid) {
                toast.error(batteryValidation.errorMessage, { position: 'bottom-right' });
                return -1;
            }
        }

        var header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        let formData = new FormData();
        formData.append("inItem", _inItem.item_id);
        formData.append("c_id", c_id.replace(/\s/g, ''));
        formData.append("ouItem", _ouItem.id);
        formData.append("check", check);
        formData.append("check2", check2);
        formData.append("list_id", list_id);
        formData.append("battery", battery);
        formData.append("notes", notes);

        if (op && op.length > 0) {
            for (let index = 0; index < op.length; index++) {
                formData.append("op_ids", op[index].id);
            }
        }

        axios({ url: host + `users/sana/orders/new`, method: "post", data: formData, headers: header })
            .then(response => {
                this.setState({ isConfirmLoading: false });
                window.location.href = `/phoneinfo?id=${response.data.id.uuid}`;
            })
            .catch(error => {
                toast.error(error.response?.data?.message || 'حدث خطأ', { position: 'bottom-right' });
                this.setState({ isConfirmLoading: false });
                const autoDiv = document.getElementById('autoDiv');
                const autoDivF = document.getElementById('autoDivF');
                if (autoDiv) autoDiv.style.zIndex = 800;
                if (autoDivF) autoDivF.style.zIndex = 800;
            });
    }

    render() {
        if (cookies.get("tokenUser")) {
            return (
                <ThemeProvider theme={theme}>
                    <Context.Consumer>
                        {ctx => (
                            <div style={styles.pageWrapper}>
                                <GlobalStyles />
                                
                                {/* Background Orbs */}
                                <div style={styles.backgroundOrbs}>
                                    <div style={styles.orb1}></div>
                                    <div style={styles.orb2}></div>
                                    <div style={styles.orb3}></div>
                                </div>

                                {/* Navbar */}
                                <nav style={styles.navbar}>
                                    <div style={styles.pageTitle}>
                                        🔧 إضافة جهاز جديد
                                    </div>
                                    <Link to='/s_home' style={{ textDecoration: 'none' }}>
                                        <div style={styles.backButton} className="back-btn">
                                            <span>العودة للرئيسية</span>
                                            <Icon icon="circle-arrow-left" size={20} color="#fff" />
                                        </div>
                                    </Link>
                                </nav>

                                {/* Main Content */}
                                <div style={styles.mainContent}>
                                    {/* Card 1: Device Selection */}
                                    <div style={{...styles.card, animationDelay: '0.1s'}} className="card-animate">
                                        <Row style={{ direction: 'rtl' }}>
                                            <Col md={4}>
                                                <div style={styles.sectionTitle}>
                                                    <span style={{...styles.sectionIcon, background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', color: '#fff'}}>📋</span>
                                                    رقم القائمة
                                                </div>
                                                <div style={styles.inputWrapper}>
                                                    <input
                                                        type="text"
                                                        placeholder="ادخل رقم القائمة"
                                                        disabled
                                                        value={this.state.listId || ''}
                                                        id="list_id"
                                                        style={styles.styledTextInput}
                                                        className="styled-input"
                                                        onChange={(e) => {
                                                            if (e.target.value.length > 3) {
                                                                this.get_list_items(e.target.value);
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </Col>

                                            <Col md={4}>
                                                <div style={styles.sectionTitle}>
                                                    <span style={{...styles.sectionIcon, background: 'linear-gradient(135deg, #ec4899, #f43f5e)', color: '#fff'}}>📱</span>
                                                    نوع الجهاز الأولي
                                                </div>
                                                <div style={styles.inputWrapper}>
                                                    <div id="spI" style={{ display: "none", justifyContent: 'center', padding: '20px' }}>
                                                        <CircularProgress sx={{ color: '#6366f1' }} />
                                                    </div>
                                                    <div id="autoDivF" style={{ width: "100%", zIndex: 800 }}>
                                                        <Autocomplete
                                                            disableClearable
                                                            disablePortal={false}
                                                            onChange={(event, value) => this.onSelect(value)}
                                                            id="phoneInput"
                                                            options={this.state.items}
                                                            getOptionDisabled={(option) => option.disabled === true}
                                                            getOptionLabel={(option) => option.name || ''}
                                                            fullWidth
                                                            noOptionsText="لا توجد نتائج"
                                                            loadingText="جاري التحميل..."
                                                            renderInput={(params) => (
                                                                <TextField 
                                                                    {...params} 
                                                                    placeholder="ادخل رقم القائمة لتحميل الأجهزة" 
                                                                    label="الجهاز الأولي"
                                                                    dir="rtl"
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>

                                            <Col md={4}>
                                                <div style={styles.sectionTitle}>
                                                    <span style={{...styles.sectionIcon, background: 'linear-gradient(135deg, #10b981, #059669)', color: '#fff'}}>🔩</span>
                                                    قطع الغيار المستخدمة
                                                </div>
                                                <div style={styles.inputWrapper}>
                                                    <div id="spp" style={{ display: "none", justifyContent: 'center', padding: '20px' }}>
                                                        <CircularProgress sx={{ color: '#10b981' }} />
                                                    </div>
                                                    <div id="psl">
                                                        <Select 
                                                            isMulti 
                                                            id="psi"
                                                            ref={ref => { this.selectRef = ref; }}
                                                            onChange={(newValue) => this.setState({ optionsSelcted: newValue })}
                                                            options={this.state.options}
                                                            styles={customSelectStyles}
                                                            placeholder="اختر قطع الغيار..."
                                                            noOptionsMessage={() => "لا توجد قطع غيار"}
                                                            isRtl={true}
                                                            menuPortalTarget={document.body}
                                                            menuPosition="fixed"
                                                        />
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Card 2: Device Details */}
                                    <div style={{...styles.card, animationDelay: '0.2s'}} className="card-animate">
                                        <Row style={{ direction: 'rtl' }}>
                                            <Col md={3}>
                                                <div style={styles.sectionTitle}>
                                                    <span style={{...styles.sectionIcon, background: 'linear-gradient(135deg, #f59e0b, #d97706)', color: '#fff'}}>📱</span>
                                                    الجهاز النهائي
                                                </div>
                                                <div style={styles.inputWrapper}>
                                                    <div id="autoDiv" style={{ width: "100%", zIndex: 800 }}>
                                                        <Autocomplete
                                                            key={this.state.outDeviceKey}
                                                            disablePortal={false}
                                                            onChange={(event, value) => this.onSelectFin(value)}
                                                            options={this.state.filteredOutItems}
                                                            getOptionLabel={(option) => option.name || ''}
                                                            fullWidth
                                                            noOptionsText="لا توجد نتائج"
                                                            loadingText="جاري التحميل..."
                                                            renderInput={(params) => (
                                                                <TextField 
                                                                    {...params} 
                                                                    label="الجهاز النهائي"
                                                                    dir="rtl"
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                </div>
                                            </Col>

                                            <Col md={3}>
                                                <div style={styles.sectionTitle}>
                                                    <span style={{...styles.sectionIcon, background: 'linear-gradient(135deg, #06b6d4, #0891b2)', color: '#fff'}}>🔢</span>
                                                    الرقم التسلسلي
                                                </div>
                                                <div style={styles.inputWrapper}>
                                                    <input
                                                        type="text"
                                                        placeholder="ادخل معرف الجهاز"
                                                        id="c_id"
                                                        style={styles.styledTextInput}
                                                        className="styled-input"
                                                        onChange={(e) => {
                                                            if (e.target.value.length > 8) {
                                                                axios.get(host + `users/sana/check/phone/${e.target.value.replace(/\s/g, '')}`)
                                                                    .then(res => {
                                                                        const checkDev = document.getElementById('checkDev');
                                                                        const devNumber = document.getElementById('devNumber');
                                                                        if (res.data.phone) {
                                                                            if (checkDev) checkDev.style.display = "block";
                                                                            if (devNumber) {
                                                                                devNumber.innerText = res.data.phone.id;
                                                                                devNumber.style.fontSize = "20px";
                                                                                devNumber.style.fontWeight = "bolder";
                                                                                devNumber.style.color = "#ef4444";
                                                                                devNumber.style.margin = "5px";
                                                                            }
                                                                        } else {
                                                                            if (checkDev) checkDev.style.display = "none";
                                                                        }
                                                                    })
                                                                    .catch(error => console.log(error.response));
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </Col>

                                            <Col md={2}>
                                                <div style={styles.sectionTitle}>
                                                    <span style={{...styles.sectionIcon, background: 'linear-gradient(135deg, #84cc16, #65a30d)', color: '#fff'}}>🔋</span>
                                                    نسبة البطارية
                                                </div>
                                                <div style={styles.inputWrapper}>
                                                    <input
                                                        type="number"
                                                        placeholder="النسبة %"
                                                        id="battery"
                                                        min="1"
                                                        max="100"
                                                        value={this.state.batteryValue}
                                                        onChange={this.handleBatteryChange}
                                                        style={{
                                                            ...styles.styledTextInput,
                                                            ...(this.state.batteryError ? styles.batteryInputError : {})
                                                        }}
                                                        className={`styled-input ${this.state.batteryError ? 'input-error' : ''}`}
                                                    />
                                                    {this.state.batteryError && (
                                                        <div style={styles.batteryErrorText}>
                                                            <span>⚠️</span>
                                                            <span>{this.state.batteryErrorMessage}</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </Col>

                                            <Col md={4}>
                                                <div style={styles.sectionTitle}>
                                                    <span style={{...styles.sectionIcon, background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)', color: '#fff'}}>📝</span>
                                                    الملاحظات
                                                </div>
                                                <div style={styles.inputWrapper}>
                                                    <textarea
                                                        id="notes"
                                                        placeholder="ادخل الملاحظات إن وجدت..."
                                                        style={styles.styledTextarea}
                                                        className="styled-input"
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* Device Warning */}
                                        <Row id="checkDev" style={{ display: "none", marginTop: '24px' }}>
                                            <Col>
                                                <div style={{...styles.alertBox, ...styles.alertDanger}}>
                                                    <span style={{ fontSize: '24px' }}>⚠️</span>
                                                    <span>
                                                        هذا الجهاز تم إضافته مسبقاً برقم <span id="devNumber"></span> - تأكد من هذا الجهاز أو في حال كان الجهاز راجع تأكد من اختيار نوع الفحص كـ راجع
                                                    </span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Card 3: Check Type */}
                                    <div style={{...styles.card, animationDelay: '0.3s'}} className="card-animate">
                                        <div style={{...styles.alertBox, ...styles.alertInfo}}>
                                            <span style={{ fontSize: '24px' }}>🔍</span>
                                            <span>يرجى تحديد نوع الفحص أو الصيانة</span>
                                        </div>
                                        <div style={styles.radioGroup}>
                                            <div className="radio-card" style={styles.radioCard}>
                                                <input 
                                                    type="radio" 
                                                    name="group2" 
                                                    value="new" 
                                                    id="check_new"
                                                    style={styles.radioInput}
                                                />
                                                <label htmlFor="check_new" style={styles.radioLabel}>
                                                    <span style={{ fontSize: '20px' }}>✨</span>
                                                    جهاز جديد
                                                </label>
                                            </div>
                                            <div className="radio-card" style={styles.radioCard}>
                                                <input 
                                                    type="radio" 
                                                    name="group2" 
                                                    value="rej" 
                                                    id="check_rej"
                                                    style={styles.radioInput}
                                                />
                                                <label htmlFor="check_rej" style={styles.radioLabel}>
                                                    <span style={{ fontSize: '20px' }}>🔄</span>
                                                    فحص راجع
                                                </label>
                                            </div>
                                        </div>

                                        <div style={styles.divider}></div>

                                        <div style={{...styles.alertBox, ...styles.alertSuccess}}>
                                            <span style={{ fontSize: '24px' }}>📤</span>
                                            <span>يرجى تحديد نوع التحويل</span>
                                        </div>
                                        <div style={styles.radioGroup}>
                                            <div className="radio-card" style={styles.radioCard}>
                                                <input 
                                                    type="radio" 
                                                    name="group1" 
                                                    value="inv" 
                                                    id="transfer_inv"
                                                    style={styles.radioInput}
                                                />
                                                <label htmlFor="transfer_inv" style={styles.radioLabel}>
                                                    <span style={{ fontSize: '20px' }}>🔬</span>
                                                    تحويل للمخزن
                                                </label>
                                            </div>
                                            <div className="radio-card" style={styles.radioCard}>
                                                <input 
                                                    type="radio" 
                                                    name="group1" 
                                                    value="soft" 
                                                    id="transfer_soft"
                                                    style={styles.radioInput}
                                                />
                                                <label htmlFor="transfer_soft" style={styles.radioLabel}>
                                                    <span style={{ fontSize: '20px' }}>💿</span>
                                                    تحويل سوفت
                                                </label>
                                            </div>
                                            <div className="radio-card" style={styles.radioCard}>
                                                <input 
                                                    type="radio" 
                                                    name="group1" 
                                                    value="sana" 
                                                    id="transfer_sana"
                                                    style={styles.radioInput}
                                                />
                                                <label htmlFor="transfer_sana" style={styles.radioLabel}>
                                                    <span style={{ fontSize: '20px' }}>🔧</span>
                                                    إبقاء في الصيانة
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Submit Button */}
                                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '32px' }}>
                                        <Component initialState={{ isShown: false, isConfirmLoading: false }}>
                                            {({ state, setState }) => (
                                                <Pane>
                                                    <Dialog
                                                        isShown={state.isShown}
                                                        title='تأكيد إضافة الجهاز'
                                                        onCloseComplete={() => {
                                                            const autoDiv = document.getElementById('autoDiv');
                                                            const autoDivF = document.getElementById('autoDivF');
                                                            if (autoDiv) autoDiv.style.zIndex = 800;
                                                            if (autoDivF) autoDivF.style.zIndex = 800;
                                                            setState({ isShown: false });
                                                        }}
                                                        confirmLabel="تأكيد الإضافة"
                                                        cancelLabel="إلغاء"
                                                        isConfirmLoading={this.state.isConfirmLoading}
                                                        onConfirm={() => {
                                                            let _inItem = this.state.itemIn;
                                                            let _ouItem = this.state.itemOut;
                                                            let c_id = document.getElementById("c_id").value;
                                                            let battery = this.state.batteryValue;
                                                            var radios = document.getElementsByName('group1');
                                                            var radios2 = document.getElementsByName('group2');

                                                            let check = "";
                                                            let check2 = "";

                                                            for (var i = 0, length = radios.length; i < length; i++) {
                                                                if (radios[i].checked) {
                                                                    check = radios[i].value;
                                                                    break;
                                                                }
                                                            }
                                                            for (var i = 0, length = radios2.length; i < length; i++) {
                                                                if (radios2[i].checked) {
                                                                    check2 = radios2[i].value;
                                                                    break;
                                                                }
                                                            }

                                                            if (!check2) {
                                                                toast.error('اختر نوع الفحص', { position: 'bottom-right' });
                                                                return -1;
                                                            }
                                                            if (!c_id) {
                                                                toast.error('ادخل الرقم التسلسلي', { position: 'bottom-right' });
                                                                return -1;
                                                            }
                                                            if (!check) {
                                                                toast.error('اختر نوع التحويل', { position: 'bottom-right' });
                                                                return -1;
                                                            }
                                                            if (!_ouItem) {
                                                                toast.error('ادخل الجهاز النهائي', { position: 'bottom-right' });
                                                                return -1;
                                                            }
                                                            
                                                            // التحقق من صحة نسبة البطارية عند التأكيد
                                                            if (battery !== '' && battery !== null && battery !== undefined) {
                                                                const batteryValidation = this.validateBattery(battery);
                                                                if (!batteryValidation.isValid) {
                                                                    toast.error(batteryValidation.errorMessage, { position: 'bottom-right' });
                                                                    return -1;
                                                                }
                                                            }
                                                            
                                                            this.setState({ isConfirmLoading: true });
                                                            this.addNew();
                                                        }}
                                                    >
                                                        <div style={{...styles.alertBox, ...styles.alertDanger, margin: 0}}>
                                                            <span style={{ fontSize: '24px' }}>❓</span>
                                                            <span>هل تريد فعلاً إدخال هذا الجهاز؟</span>
                                                        </div>
                                                    </Dialog>

                                                    <button
                                                        onClick={() => {
                                                            // التحقق من صحة البطارية قبل فتح نافذة التأكيد
                                                            if (this.state.batteryError) {
                                                                toast.error('يرجى تصحيح نسبة البطارية أولاً', { position: 'bottom-right' });
                                                                return;
                                                            }
                                                            
                                                            const autoDiv = document.getElementById('autoDiv');
                                                            const autoDivF = document.getElementById('autoDivF');
                                                            if (autoDiv) autoDiv.style.zIndex = 1;
                                                            if (autoDivF) autoDivF.style.zIndex = 1;
                                                            setState({ isShown: true });
                                                        }}
                                                        style={styles.submitButton}
                                                        className="submit-btn"
                                                    >
                                                        <span>إضافة الجهاز</span>
                                                        <span style={{ fontSize: '20px' }}>➕</span>
                                                    </button>
                                                </Pane>
                                            )}
                                        </Component>
                                    </div>
                                </div>

                                <ToastContainer
                                    position="bottom-left"
                                    autoClose={5000}
                                    hideProgressBar={false}
                                    newestOnTop
                                    closeOnClick
                                    rtl={true}
                                    pauseOnFocusLoss
                                    draggable
                                    pauseOnHover
                                    theme="colored"
                                />
                            </div>
                        )}
                    </Context.Consumer>
                </ThemeProvider>
            );
        } else {
            return <Login />;
        }
    }
}

export default Category;